import { Stack } from '@mui/material'
import { KeyboardArrowRight, KeyboardArrowLeft } from '@mui/icons-material'
import { ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../hooks/useTexts'
import { Footer } from './Footer'

export function ConfigureFormatFooter() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    close,
    status,
    invalid,
    data: { customizeColumns, multiTerritory, columnsState },
  } = useController()

  return (
    <Footer>
      {multiTerritory ? (
        <ModalFooterButton
          onClick={handlers.onGoToTerritoriesSelection}
          testid="modal-tertiary-button"
        >
          <KeyboardArrowLeft />
          {texts.prevStepButton}
        </ModalFooterButton>
      ) : (
        <div />
      )}
      <Stack gap={1} direction="row">
        <ModalFooterButton testid="modal-secondary-button" onClick={close}>
          {texts.cancelButton}
        </ModalFooterButton>
        {customizeColumns ? (
          <ModalFooterButton
            variant="contained"
            testid="modal-primary-button"
            onClick={handlers.onGoToColumnSelection}
            loading={columnsState.status === 'loading'}
          >
            {texts.nextStepButton}
            <KeyboardArrowRight />
          </ModalFooterButton>
        ) : (
          <ModalFooterButton
            disabled={invalid || status !== 'ready'}
            onClick={handlers.onLegacyExport}
            variant="contained"
            loading={handlers.isLoading}
            testid="modal-primary-button"
          >
            {texts.exportButton}
          </ModalFooterButton>
        )}
      </Stack>
    </Footer>
  )
}
